/* global session, Q */
// --  se uita la denumirea de coloana 
Q.validators = {
    CNP: (v) => {
        if ((v + '').trim().length) {

            v = v + '';

            if (v.length !== 13) {
                Q.validate_error_message = "Trebuie sa aiba 13 cifre!";
                return 1;
            }

            var MIDX = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
            var SUM = 0;

            for (let i = 0; i < 12; i++) {
                let N = v.charCodeAt(i) - 48;
                if (N < 0 || N > 9) {
                    Q.validate_error_message = "CNP contine NUMAI cifre!";
                    return 1;
                }
                SUM += N * MIDX[i];
            }

            var C = SUM % 11;
            if (C === 10) C = 1;

            if (+v[12] !== C) {
                Q.validate_error_message = "VERIFICATI CIFRELE INTRODUSE!";
                return 1;
            }
        }
    },
    CUI: (v) => {
        if (!(v = (v + '').trim()).length)
            return;

        v = v.toUpperCase().replace(/^RO/, '');

        if (!/^\d{2,10}$/.test(v)) {
            Q.validate_error_message = "CUI trebuie să conțină între 2 și 10 cifre.";
            return 1;
        }

        const control = +v.slice(-1);
        const digits = v.slice(0, -1);
        const weights = "753217532";

        let sum = 0;

        for (let i = 0; i < digits.length; i++) {
            sum += +digits[digits.length - 1 - i] *
                +weights[weights.length - 1 - i];
        }

        let check = (sum * 10) % 11;
        if (check === 10)
            check = 0;

        if (check !== control) {
            Q.validate_error_message = "CUI invalid. Verificați cifrele introduse.";
            return 1;
        }
    },

    email: (v) => {
        if (!/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v)) {
            Q.validate_error_message = 'email format required! <hr/>ex: aburel<m style="color:lime">@</m>gamil<m style="color:lime">.</m>com';
            return 1;
        }
    },
    minmax: (v) => {
        var mi = parseInt($.getA('minlength')) || 0,
            ma = parseInt($.getA('maxlength')) || 100000;
        var reg = new RegExp(".{" + mi + "," + ma + "}", "i");
        if (!reg.test(v)) {
            Q.validate_error_message = 'please check field above<br><br>min ' +
                mi + ' chars REQUIRED ' + ' - max  ' + ma + ' chars ALLOWED !';
            return 1;
        }
    },
    integer: (v) => {
        if (!/^\d*$/.test(v)) {
            Q.validate_error_message = "INTEGER: only numbers allowed";
            return 1;
        }
    }
};

const __validator_cache = Object.create(null);

Q.is_invalid = new Proxy({}, {

    get(_, spec) {

        // 1. Separate rule logic from custom error message using "::"
        let [rule, message] = String(spec).split(/\s*::\s*/, 2);
        rule = rule.trim();

        // 2. Built-in validator (CNP, CUI, email, etc.)
        if (Q.validators[rule]) {

            return ($) => {
                if ($ && typeof $ === "object" && "value" in $) $ = $.value;

                Q.validate_error_message = "";
                let r = Q.validators[rule]($);

                if (r && message) Q.validate_error_message = message;
                return r;
            };
        }

        // 3. Expression validator (Handles multi-statement JS)
        return __validator_cache[spec] ??= (() => {

            // Split semicolon-separated statements while ignoring semicolons inside brackets/braces
            let statements = rule.split(/;(?![^{}\[\]]*\})/);
            let lastCondition = statements.pop().trim();
            let setupCode = statements.length ? statements.join(";") + ";" : "";

            // Create executable function: runs setup code, then checks condition
            let test = new Function(
                "$",
                `"use strict"; 
                 ${setupCode} 
                 return !!(${lastCondition});` // Returns true if VALID
            );

            return ($) => {

                if ($ && typeof $ === "object" && "value" in $) $ = $.value;

                Q.validate_error_message = "";

                try {

                    // If condition passes (returns true), it is valid!
                    if (test($)) return 0;

                    // Otherwise failed validation
                    Q.validate_error_message = message || `Must satisfy: ${lastCondition}`;
                    return 1;

                } catch (e) {

                    Q.validate_error_message =
                        "Invalid validation expression:\n" +
                        rule + "\n\nError: " + e.message;

                    return 1;
                }
            };

        })();
    }
});


// Helper to split multiple rules separated ONLY by '|'
function getRulesFromElement(e) {
    let attr = e.getAttribute("validate") || "";
    // Splits on '|' only (ignores '|' inside string literals if needed)
    return attr.split(/\s*\|\s*/).map(s => s.trim()).filter(Boolean);
}



/**
 *   * validarea formelor
 * @example
 *      TE.before_save = function(sql_do){
 *          ...
 *          return Q.validate(_i);
 *      }
 *   @param {DomElement} context
 *   @return {[0,1]}
 *  1 inseamna intreruperea salvarii si semnalizarea primului input invalid
 */

Q.validate = function (context, sql_do = null) {

    let tables,
        inputs = context ? context.find(":invalid") : Q(":invalid");

    if (sql_do) {
        tables = sql_do.map(s => s.table);
    }

    //────────────────────────────────────────────
    // Native HTML validation
    //────────────────────────────────────────────

    for (let i = 0; i < inputs.length; i++) {

        let e = inputs[i];

        if (!e.offsetParent)
            continue;

        if (tables && !tables.has(e.tb_name))
            continue;

        if (e.validity && !e.validity.valid) {

            setTimeout(() => e.reportValidity(), 0);
            return 1;
        }
    }

    //────────────────────────────────────────────
    // Custom elements ([invalid])
    //────────────────────────────────────────────

    let C = context ? context.find("[invalid]") : Q("[invalid]");

    if (C.length) {

        let e = C[0];

        if (e.tagName === "X-RADIO")
            e.buttons[0].show_error("<h5>CHOOSE AN OPTION</h5>", 3000);
        else
            e.show_error(e.validation_text || "REQUIRED FIELD", 3000);

        return 1;
    }


    // ────────────────────────────────────────────
    // Declarative validate=""
    // ────────────────────────────────────────────

    let V = context ? context.find("[validate]") : Q("[validate]");

    for (let i = 0; i < V.length; i++) {

        let e = V[i];

        if (!e.offsetParent) continue;
        if (tables && !tables.has(e.tb_name)) continue;

        // USE THE SAME HELPER HERE
        let rules = getRulesFromElement(e);

        for (let spec of rules) {
            let err = Q.is_invalid[spec](e);
            if (!err) continue;

            let msg = Q.validate_error_message || "Invalid value";

            if (e.setCustomValidity) {
                e.setCustomValidity(msg);
                e.reportValidity();
            } else if (e.show_error) {
                e.show_error(msg, 3000);
            }

            return 1;
        }
    }

    return 0;
};



function _check_validate_rules(e) {
    let rules = (e.getAttribute("validate") || "")
        .split(/\s*\|\s*/)  // mai multe reguli se pot adauga  cu bar separator  code1::message | code2
        .filter(Boolean);

    for (let spec of rules) {
        if (Q.is_invalid[spec](e))
            return Q.validate_error_message || "Invalid value";
    }
    return null;
}


document.addEventListener("DOMContentLoaded", ev => {

    // clear bubble immediately while typing
    document.addEventListener("input", (ev) => {
        let e = ev.target;
        if (!e.hasAttribute || !e.hasAttribute("validate")) return;
        if (!e.setCustomValidity) return;

        e.setCustomValidity("");
    });

    // revalidate + report on blur (capture, since blur doesn't bubble)
    document.addEventListener("blur", (ev) => {
        let e = ev.target;
        if (!e.hasAttribute || !e.hasAttribute("validate")) return;
        if (!e.setCustomValidity) return;
        if (e._revalidating) return; // stop reentrant loop

        let msg = _check_validate_rules(e);
        e.setCustomValidity(msg || "");

        if (msg) {
            e._revalidating = true;
            e.reportValidity(); // refocuses e synchronously

            if (e.value === '') {
                e.blur();
                e._revalidating = false;
            } else {
                queueMicrotask(async () => {
                    await wait(3000);
                    if (!e.matches(":focus")) {
                        e.blur();
                    }
                    e._revalidating = false;
                });
            }
        }
    }, true);

});
